/**
 * THU THUAT SCHEDULER - Styles
 * Extracted from docs/prototype.jsx
 */

// Font family constant
const font = "'Roboto', system-ui, sans-serif";

// Global CSS (animations, resets)
export const globalCSS = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  html { -webkit-font-smoothing: antialiased; }
  input, button { font-family: inherit; }

  @keyframes slideDown {
    from { opacity: 0; transform: translateY(-8px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes toastIn {
    from { opacity: 0; transform: translateY(16px) scale(0.95); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
  }
`;

// Status configuration
export const STATUS_CONFIG = {
  PENDING:     { label: 'Chờ',      color: '#94a3b8', bg: '#f1f5f9', ring: 'transparent' },
  IN_PROGRESS: { label: 'Đang làm', color: '#2563eb', bg: '#eff6ff', ring: '#bfdbfe' },
  COMPLETED:   { label: 'Xong',     color: '#16a34a', bg: '#f0fdf4', ring: 'transparent' },
  CANCELLED:   { label: 'Huỷ',      color: '#dc2626', bg: '#fef2f2', ring: 'transparent' },
};

// All inline styles
export const styles = {
  // Root
  root: {
    fontFamily: font,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    background: '#f8fafc',
    color: '#0f172a',
    overflow: 'hidden',
  },

  // Header
  header: {
    background: '#fff',
    borderBottom: '1px solid #e2e8f0',
    zIndex: 40,
    flexShrink: 0,
  },
  headerInner: {
    maxWidth: 1350,
    margin: '0 auto',
    padding: '0 20px',
    height: 84,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: 24 },
  headerRight: { display: 'flex', alignItems: 'center', gap: 18 },
  logo: { display: 'flex', alignItems: 'center', gap: 12 },
  logoText: { fontWeight: 800, fontSize: 24, color: '#1e40af', letterSpacing: '-0.02em' },
  dateBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    background: '#f8fafc',
    border: '1px solid #e2e8f0',
    borderRadius: 8,
    padding: '6px 15px',
  },
  dateInput: {
    border: 'none',
    background: 'transparent',
    fontSize: 20,
    fontWeight: 600,
    color: '#334155',
    fontFamily: font,
    cursor: 'pointer',
    outline: 'none',
  },
  statsChips: { display: 'flex', gap: 9 },
  chip: {
    fontSize: 16,
    fontWeight: 700,
    padding: '4px 12px',
    borderRadius: 6,
    whiteSpace: 'nowrap',
  },
  btnAdd: {
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    padding: '12px 21px',
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
    transition: 'all 0.15s',
  },
  btnClose: {
    display: 'flex',
    alignItems: 'center',
    gap: 9,
    padding: '12px 21px',
    background: '#f1f5f9',
    color: '#64748b',
    border: '1px solid #e2e8f0',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
  },

  // Add Panel
  addPanelWrap: {
    background: '#fff',
    borderBottom: '1px solid #e2e8f0',
    zIndex: 30,
    flexShrink: 0,
    animation: 'slideDown 0.2s ease-out',
  },

  // Form
  formWrap: { maxWidth: 1350, margin: '0 auto', padding: '30px 30px 24px' },
  formSection: { marginBottom: 24 },
  formLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 15,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    color: '#94a3b8',
    marginBottom: 12,
  },
  formLabelHint: {
    marginLeft: 'auto',
    fontSize: 15,
    fontWeight: 600,
    color: '#cbd5e1',
    textTransform: 'none',
    letterSpacing: 0,
  },
  formInput: {
    width: '100%',
    fontSize: 27,
    fontWeight: 700,
    padding: '18px 24px',
    border: '2px solid #e2e8f0',
    borderRadius: 12,
    outline: 'none',
    fontFamily: font,
    color: '#0f172a',
    transition: 'border-color 0.15s',
  },
  procGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))',
    gap: 12,
  },
  procBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '15px 18px',
    background: '#fff',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
    transition: 'all 0.12s',
    textAlign: 'left',
  },
  procBtnActive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '15px 18px',
    background: '#1e40af',
    border: '1.5px solid #1e40af',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
    color: '#fff',
    textAlign: 'left',
    boxShadow: '0 2px 8px rgba(30,64,175,0.25)',
  },
  procName: { fontSize: 18, fontWeight: 700 },
  procDur: { fontSize: 15, fontWeight: 600, opacity: 0.6 },
  hotkey: {
    fontSize: 15,
    fontWeight: 800,
    fontFamily: 'monospace',
    background: '#f1f5f9',
    color: '#94a3b8',
    padding: '3px 9px',
    borderRadius: 4,
    border: '1px solid #e2e8f0',
  },
  hotkeyActive: {
    fontSize: 15,
    fontWeight: 800,
    fontFamily: 'monospace',
    background: 'rgba(255,255,255,0.2)',
    color: '#fff',
    padding: '3px 9px',
    borderRadius: 4,
    border: '1px solid rgba(255,255,255,0.3)',
  },
  formFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: 12,
    borderTop: '1px solid #f1f5f9',
  },
  formFooterInfo: {},
  selectedInfo: { fontSize: 18, fontWeight: 600, color: '#64748b' },
  btnSubmit: {
    padding: '15px 30px',
    background: '#2563eb',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    fontWeight: 700,
    fontSize: 20,
    fontFamily: font,
    cursor: 'pointer',
    transition: 'all 0.15s',
  },

  // Main
  main: {
    flex: 1,
    overflowY: 'auto',
    padding: '30px 24px',
  },
  container: { maxWidth: 1080, margin: '0 auto' },

  // Toolbar
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    marginBottom: 24,
    flexWrap: 'wrap',
  },
  filterTabs: {
    display: 'flex',
    gap: 6,
    background: '#f1f5f9',
    borderRadius: 10,
    padding: 3,
    flexShrink: 0,
  },
  filterTab: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 18px',
    background: 'transparent',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 18,
    fontWeight: 600,
    color: '#64748b',
    transition: 'all 0.15s',
    whiteSpace: 'nowrap',
  },
  filterTabActive: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '9px 18px',
    background: '#fff',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 18,
    fontWeight: 700,
    color: '#0f172a',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    whiteSpace: 'nowrap',
  },
  filterBadge: {
    fontSize: 15,
    fontWeight: 700,
    background: '#e2e8f0',
    color: '#64748b',
    padding: '2px 9px',
    borderRadius: 6,
    minWidth: 30,
    textAlign: 'center',
  },
  filterBadgeActive: {
    fontSize: 15,
    fontWeight: 700,
    background: '#2563eb',
    color: '#fff',
    padding: '2px 9px',
    borderRadius: 6,
    minWidth: 30,
    textAlign: 'center',
  },
  searchWrap: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flex: 1,
    minWidth: 270,
    background: '#fff',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    padding: '9px 18px',
    transition: 'border-color 0.15s',
  },
  searchInput: {
    flex: 1,
    border: 'none',
    outline: 'none',
    fontSize: 20,
    fontWeight: 500,
    color: '#0f172a',
    fontFamily: font,
    background: 'transparent',
    minWidth: 0,
  },
  searchClear: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 22,
    height: 22,
    background: '#f1f5f9',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    flexShrink: 0,
  },
  searchKbd: {
    fontSize: 16,
    fontWeight: 700,
    fontFamily: 'monospace',
    background: '#f1f5f9',
    color: '#94a3b8',
    padding: '2px 9px',
    borderRadius: 4,
    border: '1px solid #e2e8f0',
    flexShrink: 0,
  },
  filterCount: {
    fontSize: 16,
    fontWeight: 700,
    color: '#94a3b8',
    background: '#f1f5f9',
    padding: '3px 12px',
    borderRadius: 6,
    flexShrink: 0,
  },

  // Section header
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 18,
    marginBottom: 24,
  },
  sectionLabel: {
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.06em',
    color: '#94a3b8',
    whiteSpace: 'nowrap',
  },
  sectionLine: { flex: 1, height: 1, background: '#e2e8f0' },

  // Empty state
  emptyState: {
    textAlign: 'center',
    padding: '120px 30px',
    background: '#fff',
    borderRadius: 16,
    border: '2px dashed #e2e8f0',
  },
  kbd: {
    display: 'inline-block',
    padding: '3px 12px',
    background: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: 4,
    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'monospace',
  },

  // Patient list
  patientList: { display: 'flex', flexDirection: 'column', gap: 12, paddingBottom: 80 },

  // Card
  card: {
    borderRadius: 14,
    border: '1px solid #e8ecf1',
    padding: 16,
    transition: 'all 0.2s',
    animation: 'fadeUp 0.3s ease-out both',
  },
  cardTop: { display: 'flex', alignItems: 'center', gap: 18 },
  avatar: {
    width: 66,
    height: 66,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    fontSize: 21,
    flexShrink: 0,
    letterSpacing: '-0.02em',
  },
  cardInfo: { flex: 1, minWidth: 0 },
  cardNameRow: { display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' },
  cardName: { fontWeight: 700, fontSize: 22 },
  statusBadge: {
    fontSize: 15,
    fontWeight: 700,
    padding: '3px 12px',
    borderRadius: 6,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
  },
  cardMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 18,
    color: '#94a3b8',
    marginTop: 3,
    fontWeight: 500,
  },
  metaDot: { margin: '0 2px' },
  cardActions: { display: 'flex', alignItems: 'center', gap: 9, flexShrink: 0 },
  btnStart: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 21px',
    background: '#eff6ff',
    color: '#2563eb',
    border: '1px solid #bfdbfe',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 18,
    fontWeight: 700,
  },
  btnDone: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '10px 21px',
    background: '#16a34a',
    color: '#fff',
    border: 'none',
    borderRadius: 10,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 18,
    fontWeight: 700,
    boxShadow: '0 2px 8px rgba(22,163,74,0.25)',
  },
  doneLabel: {
    fontSize: 16,
    fontWeight: 700,
    color: '#94a3b8',
    background: '#f1f5f9',
    padding: '8px 15px',
    borderRadius: 8,
  },
  btnExpand: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
  },

  // Expanded card
  cardExpanded: {
    marginTop: 18,
    paddingTop: 12,
    borderTop: '1px solid #f1f5f9',
    animation: 'slideDown 0.15s ease-out',
  },
  procList: { display: 'flex', flexDirection: 'column', gap: 9, marginLeft: 84 },
  procRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    fontSize: 18,
    fontWeight: 500,
  },
  procDot: { width: 6, height: 9, borderRadius: '50%', flexShrink: 0 },
  procRowName: { fontWeight: 600, color: '#334155', flex: 1 },
  procRowTime: { color: '#94a3b8', fontFamily: 'monospace', fontSize: 16, fontWeight: 600 },
  procRowStatus: { fontSize: 15, fontWeight: 700, textTransform: 'uppercase' },
  cardExpandedFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  btnDeleteSmall: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    padding: '8px 15px',
    background: '#fef2f2',
    color: '#ef4444',
    border: '1px solid #fecaca',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 16,
    fontWeight: 700,
  },

  // Footer
  footer: {
    flexShrink: 0,
    background: '#fff',
    borderTop: '1px solid #e2e8f0',
    padding: '18px 30px',
    zIndex: 40,
  },
  footerInner: {
    maxWidth: 1350,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 24,
  },
  footerLeft: { display: 'flex', alignItems: 'center', gap: 12 },
  footerText: { fontSize: 20, fontWeight: 600, color: '#64748b' },
  progressWrap: { display: 'flex', alignItems: 'center', gap: 15, flex: 1, maxWidth: 390 },
  progressTrack: {
    flex: 1,
    height: 9,
    background: '#f1f5f9',
    borderRadius: 99,
    overflow: 'hidden',
  },
  progressBar: {
    height: '100%',
    background: 'linear-gradient(90deg, #22c55e, #16a34a)',
    borderRadius: 99,
    transition: 'width 0.8s cubic-bezier(0.4,0,0.2,1)',
  },
  progressLabel: { fontSize: 20, fontWeight: 800, color: '#16a34a', minWidth: 54, textAlign: 'right' },

  // Toast
  toast: {
    position: 'fixed',
    bottom: 80,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '15px 27px',
    borderRadius: 12,
    color: '#fff',
    fontSize: 20,
    fontWeight: 700,
    fontFamily: font,
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    animation: 'toastIn 0.25s ease-out',
    zIndex: 100,
  },

  // Overlay / Confirm
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.4)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 90,
  },
  confirmBox: {
    background: '#fff',
    borderRadius: 16,
    padding: 24,
    width: 480,
    boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
    animation: 'fadeUp 0.2s ease-out',
  },
  btnCancel: {
    padding: '12px 24px',
    background: '#f1f5f9',
    border: '1px solid #e2e8f0',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 20,
    fontWeight: 600,
    color: '#64748b',
  },
  btnDanger: {
    padding: '12px 24px',
    background: '#ef4444',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: font,
    fontSize: 20,
    fontWeight: 700,
    color: '#fff',
  },

  // Modal (for add patient)
  modalOverlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.5)',
    backdropFilter: 'blur(4px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 50,
    padding: 20,
  },
  modalContent: {
    background: '#fff',
    borderRadius: 16,
    width: '100%',
    maxWidth: 1050,
    maxHeight: '90vh',
    overflow: 'auto',
    boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
    animation: 'fadeUp 0.25s ease-out',
  },
  modalHeader: {
    padding: '24px 30px',
    borderBottom: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 700,
    color: '#0f172a',
  },
  modalBody: {
    padding: 20,
  },
  modalFooter: {
    padding: '24px 30px',
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};

export default styles;
